<template>
    <div class="flex items-center justify-start space-x-6">
        <div class="flex items-center space-x-2 text-blue-300">
            <HeroIcon 
              v-if="props.icon" 
              :iconName="icon"
              iconClass="size-8"
            />
        </div>
        <div class="">
            <div class="font-semibold text-slate-700 text-lg">{{ props.title }}</div>
            <div class="text-slate-700 text-sm">{{ props.message }}</div>
        </div>
    </div>
</template>

<script setup>
import HeroIcon from '@/Components/UI/HeroIcon.vue'
const props = defineProps({
    message: {
        type: String,
        required: false,
    },
    title:{
        type: String,
        required: false,
    },
    icon:{
        type: String,
        required: false,
    },
});
</script>